const RuntimeConfig = {
  siteUrl: import.meta.env.VITE_SITE_URL,
  discordOauthClientId: import.meta.env.VITE_DISCORD_OAUTH_CLIENT_ID,
  discordBotPermissions: import.meta.env.VITE_DISCORD_BOT_PERMISSIONS,
  debugDiscordUserIds: import.meta.env.VITE_DEBUG_DISCORD_USER_IDS.split(","),
};

export const useRuntimeConfig = () => RuntimeConfig;
